module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/sold-property-pin-f5905ce9a6bd8d212367e662ef7ccf78.svg";